<!--Design for Video consultation [when mic/video off]-->
<div class="tele-info-popup">
  <span class="tele-info-close" (click)="closePopup()">&#10005;</span>
  @if (device=='camera') {
    <div class="tele-info-graphic">
      <img src="/assets/images/tele-video-info-light.png">
    </div>
  }
  @if (device=='microphone') {
    <div class="tele-info-graphic">
      <img src="/assets/images/tele-audio-info-light.png">
    </div>
  }
  <div class="tele-info-message">
    <!-- <h2 class="text-dark text-center">Your microphone is blocked</h2> -->
    <h2 class="text-white text-center">Your {{device}} is blocked</h2>
    <div class="tele-info-details">
      <!-- <div class="for-mic">KareXpert teleconsultation needs access to your microphone. To use,</div> -->
      <div class="for-camera">{{resource}} needs access to your {{device}}. To use,</div>
      <div class="tele-info-point">
        Click the
        @if (device=='camera') {
          <span>
            {{device}}
            <img class="video-blocked" src="/assets/images/video-blocked.png">
          </span>
        }
        @if (device=='microphone') {
          <span>
            {{device}}
            <img class="video-blocked" src="/assets/images/splash-audio.png">
          </span>
        }
        blocked icon in your browser's address bar.
      </div>
      <div class="tele-info-point">
        Allow access and then refresh the page
      </div>
    </div>
  </div>
</div>
<!--Design for Video consultation [when mic/video off]-->